import { writable, derived } from "svelte/store";

export const errors = writable({});